
















import {
  Vue,
  Component,
  Watch
} from "@/shared/vuepack";
import * as routes from "@/employee/route-names";
import SettingsHeader from "@/employee/components/settings/SettingsHeader.vue";
import SettingsNavigation from "@/employee/components/settings/SettingsNavigation.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({
  components: {
    GenericLoadingSpinner,
    SettingsNavigation,
    SettingsHeader
  }
})
export default class Settings extends Vue {
  custodianSettingsStore = useCustodianSettingsStore();
  hsabAccountsStore = useHsabAccountsStore();

  routes = routes;

  @Watch("custodianSettingsStore.isLoaded")
  custodianSettingsLoaded (newVal) {
    if (newVal === true) {
      if (this.custodianSettingsStore.isHsaBankCustodian) {
        this.hsabAccountsStore.getHsabAccounts();
      } else {
        this.navigateToMyProfile();
      }
    }
  }

  @Watch("hsabAccountsStore.allHsabAccountsLoaded")
  isHsaBankCustodianChanged (newVal) {
    if (newVal === true) {
      this.navigateToMyProfile();
    }
  }

  mounted () {
    if (!this.custodianSettingsStore.isLoaded) {
      this.custodianSettingsStore.getCustodianSettings();
    } else {
      if (this.custodianSettingsStore.isHsaBankCustodian) {
        if (this.hsabAccountsStore.allHsabAccountsLoaded) {
          this.navigateToMyProfile();
        } else {
          this.hsabAccountsStore.getHsabAccounts();
        }
      } else {
        this.navigateToMyProfile();
      }
    }
  }

  navigateToMyProfile () {
    if (this.custodianSettingsStore.displayMyProfileEditMode) {
      this.$router.push({ name: routes.MyProfileEdit });
    } else {
      this.$router.push({ name: routes.MyProfileDisplay });
    }
  }
}
